import React, { useState, useEffect, useCallback } from "react";

import CartItemDetails from './CartItemDetails';
import CartItemDiscounts from './CartItemDiscounts';
import Trash from '../../../components/icons/Garbage';

import { prettyPrice } from '../utils';

const CartItem = ({
  item, couponCode, couponApplied, removeFromCart
}) => {
  const { id, delayed, displayName } = item;

  const key = `cart-item-${id}`;

  const handleRemoveFromCart = useCallback((event) => {
    event.stopPropagation();

    removeFromCart(item);
  }, [item]);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleRemoveFromCart(event);
    }
  };

  return (
    <div key={key} id={key} className="cart-item clearfix" data-cart-item-product-id={id}>
      <a href={`/${item.productPagePath}`}>
        <h2 className="name">{displayName}</h2>
      </a>
      <div className="cart-item-final-price price">${prettyPrice(item.finalPrice())}</div>
      {item.product.isCmeProduct && (
        <div className="cme-line 1">
          {
            item.product.cmeDetails.map(details => <CartItemDetails details={details} />)
          }
        </div>
      )}

      {
        item.product.countSpecifications && <div className="cme-line 1">{ item.product.countSpecifications }</div>
      }

      <CartItemDiscounts item={item} couponCode={couponCode} couponApplied={couponApplied} />

      <div className="bottom-row">
        {delayed && <span className="delayed">DELAYED</span>}
        <div role="button" tabIndex={0} onKeyDown={handleKeyDown} className="remove-item-container" onClick={handleRemoveFromCart}>
          <Trash color="#cccccc" height={18} width={20} />
        </div>
      </div>
    </div>
  );
};

export default CartItem;
